<template>
  <div id="center-3">
    <!-- <div class="area-title">
      <span>站点运营数据</span>
    </div> -->
    <div class="area-bottom">
      <div class="area-item">
        <vue-seamless-scroll :data="bycleList" :class-option="optionHover" class="seamless-warp">
          <ul class="item">
            <li v-for="(item, index) in bycleList" :key="index" class="item-height">
              <div class="li-item">{{ item.endTime.slice(10,19) }}</div>
              <div class="li-item">{{ item.regionName }}</div>
              <!-- <div class="li-item">设备：{{ item.equipmentNumber }}</div> -->
              <div class="li-item">用户：{{ item.mobile?item.mobile.replace(item.mobile.substring(3, 7), "****"):'' }}</div>
              <div class="li-item">消费：{{ item.amount }}元</div>
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
      <div class="area-item">
        <vue-seamless-scroll :data="carList" :class-option="optionHover1" class="seamless-warp">
          <ul class="item">
            <li v-for="(item, index) in carList" :key="index" class="item-height">
              <div class="item-car">{{ item.endTime.slice(10,19) }}</div>
              <div class="item-car">{{ item.regionName }}</div>
              <!-- <div class="item-car">设备：{{ item.equipmentNumber }}</div> -->
              <div class="item-car">用户：{{ item.mobile?item.mobile.replace(item.mobile.substring(3, 7), "****"):'' }}</div>
              <div class="item-car">消费：{{ item.amount }}元</div>
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </div>
  </div>
</template>
<script>
// import bastTable from "../../components/base-table.vue";
import vueSeamlessScroll from "vue-seamless-scroll";
import axios from "axios";
export default {
  data() {
    return {
      carList: [],
      bycleList: [],
      timer: null,
    };
  },
  components: {
    // bastTable,
    vueSeamlessScroll,
  },
  computed: {
    optionHover() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    optionHover1() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  created() {
    // this.init();
    this.timer = setInterval(() => {
      // setTimeout(this.init(), 0);
    }, 1000 * 10 * 6);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    this.init();
  },
  methods: {
    //   初始化数据
    init() {
      this.getDataBycle();
      this.getDataCar();
    },
    //   获取自行车数据
    getDataBycle() {
      this.$http({
        url: this.$http.adornUrl("/admin/api/realTime/getRealTimeChargingInfo"),
        method: "get",
        params: this.$http.adornParams({
          findType: 0,
        }),
      }).then(({ data }) => {
        if (data.code == 0) {
          this.bycleList = data.data;
        }
      });
    },
    // 获取汽车数据
    getDataCar() {
      // https://saas.pgzl360.com
      axios.get("https://saas.pgzl360.com/admin/api/realTime/getRealTimeChargingInfo",{params:{
        // findType: 1,
      }}).then(res=>{
        // debugger
        console.log(res,'qiche汽车订单用户列表')
        if(res.data.code ==0){
          this.carList = res.data.data
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
#center-3 {
  width: 100%;
  height: 168px;
  padding: 0 16px;
  // border: 1px solid red;
  .area-title {
    width: 284px;
    height: 32px;
    background: url("../../assets/pgzl-ranking-bg.png");
    background-size: cover;
    background-position: center center;
    color: #fff;
    font-size: 14px;
    line-height: 32px;
    span {
      margin-left: 40px;
    }
  }
  .area-bottom {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    .area-item {
      height: 100px;
    }
    .area-item:nth-child(1) {
      width: 49%;
      background: url("../../assets/pgzl-bicle-bg-1.png");
      background-size: 100% 100%;
    }
    .area-item:nth-child(2) {
      width: 49%;
      background: url("../../assets/pgzl-car-bg-1.png");
      background-size: 100% 100%;
    }
    .seamless-warp {
      height: 100px;
      overflow: hidden;
      .item-height {
        height: 40px;
        width: 100%;
        line-height: 40px;
        display: flex;
        justify-content: space-around;
        padding: 0 10px;
      }
      // .item-height:nth-child(odd) {
      //   background: #020e3a;
      // }
      // .item-height:nth-child(even) {
      //   background: #071853;
      // }
      .li-item {
        display: inline-block;
        width: 35%;
        text-align: center;
        color: #f7b500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .li-item:nth-child(1){
        width: 15%;
      }
      .li-item:nth-child(2){
        width: 15%;
      }
      .item-car {
        display: inline-block;
        width: 35%;
        text-align: center;
        color: #00ecfc;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .item-car:nth-child(1){
        width: 15%;
      }
      .item-car:nth-child(2){
        width: 15%;
      }
    }
  }
  .dv-scr-board {
    width: 442px;
    height: 136px;
    // height: 256px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/center-3.vue